import { z } from 'zod';
/** GET /healthz — process liveness only. Never touches a dependency. */
export const HealthResponse = z.object({
    status: z.literal('ok'),
    version: z.string(),
    uptimeSeconds: z.number(),
});
export const DependencyState = z.enum(['up', 'down']);
/**
 * GET /readyz — gates deployment.
 *
 * `degraded` is deliberate (PLAN.md §6.4): if Postgres is unreachable the API
 * still serves the funnel from its last known-good cached config. Config is not
 * on the hot path, and a config outage must not stop signups. Only a hard
 * dependency failure yields `down`.
 */
export const ReadyResponse = z.object({
    status: z.enum(['ready', 'degraded', 'down']),
    checks: z.object({
        postgres: DependencyState,
        redis: DependencyState,
    }),
    version: z.string(),
});
//# sourceMappingURL=health.js.map